import {IS_LOCALHOST} from '@app/env';
import i18n from '@app/i18n';
import api, {updateTokensBeforeExpire} from '@shared/api';
import {TokenStorage} from '@shared/lib/auth/tokens';

import {FetchInvoiceDetailResponse, InvoiceCreateData} from './types';

const PATH = '/uaa';
const PATH_INVOICES = 'invoice-api/api/v2/invoices';
const PATH_INVOICE_STATUS = 'invoice-api/api/invoices';

export async function fetchTinLegalName(params?: {
    query?: string;
}): Promise<
    {
        cityName: string;
        country: string;
        email: string;
        id: number;
        name: string;
        peppolSendingEnabled: boolean;
        phoneNumber: string;
        postalZone: string;
        streetName: string;
        tin: string;
    }[]
> {
    const {data} = await api.get(`${PATH}/company/search`, {params});

    return data ?? '';
}

export async function fetchDocumentInvoiceCreate(params: InvoiceCreateData) {
    return (await api.post<FetchInvoiceDetailResponse>(`${PATH_INVOICES}/load`, params)).data;
}

export async function fetchDocumentInvoiceXmlValidation(params: string): Promise<any> {
    const data: any = await api.post(`${PATH_INVOICES}/validate`, params, {
        headers: {
            'Content-Type': 'application/xml',
        },
    });
    return {
        data,
    };
}

export async function fetchInvoiceStatusRejected(uuid: string) {
    return await api.post(`${PATH_INVOICE_STATUS}/reject`, null, {params: {uuid}});
}
export async function fetchInvoiceStatusAccepted(uuid: string) {
    return await api.post(`${PATH_INVOICE_STATUS}/accept`, null, {params: {uuid}});
}

export async function downloadInvoicePDF(id?: string, tin?: string) {
    if (!id) throw Error('No ID');
    if (TokenStorage.accessToken || TokenStorage.refreshToken) {
        await updateTokensBeforeExpire();
    }
    const resolvedTin = tin ?? new URLSearchParams(window.location.search).get('tin');

    const path =
        (IS_LOCALHOST
            ? 'https://b2b-taxpayer-web.dev.tracecore.solutions'
            : window.location.origin) +
        `/invoices/print/${id}?lang=${i18n.language}&tin=${resolvedTin ?? ''}`;

    return (
        await api.post<Blob>(
            '/pdf',
            {url: path},
            {
                baseURL: `${IS_LOCALHOST ? '/local-print' : ''}/api`,
                responseType: 'blob',
            },
        )
    ).data;
}
